var createGoogleAuthContext = function createGoogleAuthContext() {
  var callbackStore = {
    callback: null
  };

  var setCallback = function setCallback(newCallback) {
    callbackStore.callback = newCallback;
  };

  var fireFakeClick = function fireFakeClick() {
    var _document$querySelect;

    // Если нажали по нашей кастомной кнопке, тригеррим нажатие скрытой кнопки от Google
    (_document$querySelect = document.querySelector('.g_id_signin div[role=button]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.click();
  };

  var mountGoogleButton = function mountGoogleButton() {
    var googleButtonContainer = document.getElementById('googleSignInDiv');
    window.google.accounts.id.renderButton(googleButtonContainer, {
      type: 'standard'
    });
  };

  var initGoogleAuth = function initGoogleAuth(clientId) {
    var scopes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    window.google.accounts.id.initialize({
      client_id: clientId,
      scope: scopes.join(' '),
      callback: function callback(response) {
        callbackStore.callback(response);
      }
    });
  };

  return {
    setCallback: setCallback,
    fireFakeClick: fireFakeClick,
    initGoogleAuth: initGoogleAuth,
    mountGoogleButton: mountGoogleButton
  };
};

export var googleAuthContext = createGoogleAuthContext();